import React from "react";
import { Col, Row } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import { useDispatch } from "react-redux";
import lottie from "lottie-web";
import DashHeader from "./DashHeader";
import "../dancss.css";
import ScalesLoT from "../lottie-files/ScalesLoT";
import Layers from "../lottie-files/Layers";
import JourneyLoT from "../lottie-files/JourneyLoT";
import { Helmet } from "react-helmet-async";
import UserValidator from "./UserValidator";
import { pushLinkToGlobalState } from "../actions/linkActions";
import RuleBookLoT from "../lottie-files/RuleBookLoT";
import LawyerLoT from "../lottie-files/LawyerLoT";

function LegalChecks({ userInfo }) {
  let dispatch = useDispatch();
  let currentUrl = window.location.href;
  let index = currentUrl.indexOf("/dashboard");
  let splitUrl = currentUrl.substring(index);
  dispatch(pushLinkToGlobalState(splitUrl));

  return (
    <>
      <Helmet>
        <title>Legal Checks</title>
        <meta
          name="description"
          content="Lacoona Legal helps you source a Legal Practitioner that suits your needs."
        />
        <link rel="canonical" href="/dashboard/find-a-lawyer" />
      </Helmet>
      {userInfo?.profile === 1 ? (
        <Col className="dashboard-scrollable-container" lg={9}>
          <DashHeader pageTitle={"Find a Lawyer"} />

          <Row className="dashboard-content-container">
            <Row className="find-lawyer-hero legal-checks px-5">
              <h1 className="serious-font">Legal Checks</h1>
            </Row>
            <Row id="legal-checks-parent">
              <Col className="checks-cards-parent mb-4 sm-12 lg-4 md-4 xl-4">
                <LinkContainer to={"/dashboard/health-check"}>
                  <div
                    className="ll-card-interact ll-thankyou-nav-card ll-ty-legalproducts p-5"
                    onMouseEnter={() => lottie.play("scales-ty")}
                    onMouseLeave={() => lottie.stop("scales-ty")}
                  >
                    <h1>Legal Health Check</h1>
                    <p>
                      All in one assessment of all your legal and compliance
                      health requirements.
                    </p>
                    <ScalesLoT aniName="scales-ty" />
                    <div className="lcn-button-brown ll-ty-go-now-btn ">
                      <span>Go now</span>
                    </div>
                  </div>
                </LinkContainer>
              </Col>
              <Col className="checks-cards-parent mb-4 sm-12 lg-6 md-6 xl-6">
                <LinkContainer to={"/dashboard/popi"}>
                  <div
                    className="ll-card-interact ll-thankyou-nav-card ll-ty-legalproducts top p-5"
                    onMouseEnter={() => lottie.play("layer-ty")}
                    onMouseLeave={() => lottie.stop("layer-ty")}
                  >
                    <h1>POPI Assessment</h1>
                    <p>Ensure your business remains POPI compliant.</p>
                    <Layers aniName="layer-ty" />
                    <div className="lcn-button-brown ll-ty-go-now-btn ">
                      <span>Go now</span>
                    </div>
                  </div>
                </LinkContainer>
              </Col>
              <Col className="checks-cards-parent mb-4 sm-12 lg-4 md-4 xl-4">
                <LinkContainer to={"/dashboard/investment-readiness"}>
                  <div
                    className="ll-card-interact ll-thankyou-nav-card ll-ty-legalproducts top p-5"
                    onMouseEnter={() => lottie.play("journey-ty")}
                    onMouseLeave={() => lottie.stop("journey-ty")}
                  >
                    <h1>Investment Readiness</h1>
                    <p>
                      Assess the state of your organisation's investment
                      readiness.
                    </p>
                    <JourneyLoT aniName="journey-ty" />
                    <div className="lcn-button-brown ll-ty-go-now-btn ">
                      <span>Go now</span>
                    </div>
                  </div>
                </LinkContainer>
              </Col>
              <Col className="checks-cards-parent sm-12 lg-4 md-4 xl-4">
                <LinkContainer to={"/dashboard/investment-due-diligence"}>
                  <div
                    className="mb-4 ll-card-interact ll-thankyou-nav-card ll-ty-legalproducts top p-5"
                    onMouseEnter={() => lottie.play("rulebook-ty")}
                    onMouseLeave={() => lottie.stop("rulebook-ty")}
                  >
                    <h1>Investment Due Diligence</h1>
                    <p>Is your company prepared to take on investment?</p>
                    <RuleBookLoT aniName="rulebook-ty" />
                    <div className="lcn-button-brown ll-ty-go-now-btn ">
                      <span>Go now</span>
                    </div>
                  </div>
                </LinkContainer>
              </Col>
              <Col className="checks-cards-parent sm-12 lg-4 md-4 xl-4">
                <LinkContainer to={"/dashboard/BBBEE"}>
                  <div
                    className="mb-4 ll-card-interact ll-thankyou-nav-card ll-ty-legalproducts top p-5"
                    onMouseEnter={() => lottie.play("rulebook-ty")}
                    onMouseLeave={() => lottie.stop("rulebook-ty")}
                  >
                    <h1>BBBEE application</h1>
                    <p>Can your company benefit from BBBEE? </p>
                    <LawyerLoT aniName="rulebook-ty" />
                    <div className="lcn-button-brown ll-ty-go-now-btn ">
                      <span>Go now</span>
                    </div>
                  </div>
                </LinkContainer>
              </Col>
            </Row>
          </Row>
        </Col>
      ) : (
        <Col className="dashboard-scrollable-container">
          <Row className="dashboard-content-container">
            <Col align="center" className="mt-5 pt-5">
              <h3>Unfortunately this page is only available to SMEs</h3>
            </Col>
          </Row>
        </Col>
      )}
      {!userInfo ? (
        <UserValidator />
      ) : (
        userInfo?.profile === 0 && <UserValidator />
      )}
    </>
  );
}

export default LegalChecks;
